import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 1200px;
  margin: 0 auto;
`;
export const SearchLabelStyle = styled.p(
  props => `
  color: white;
  padding-bottom: ${props.theme.spacing.small};
  padding-left: ${props.theme.spacing.custom(2)};
  display:flex;
  opacity: 0.6;
  font-size: 12px;
`
);

export const RadioWrapper = styled.div`
  ${props => props.theme.dF};
  ${props => props.theme.alignItemsCenter};
  ${props => props.theme.justifyStart};
  color: ${props => props.theme.colors.goWhite.base};
  max-width: 120rem;
  width: 100%;
  margin: 0 auto;
  padding: ${props => props.theme.spacing.custom(5)} 0;
`;

export const ClassWrap = styled.label`
  padding-right: ${props => props.theme.spacing.large};
  ${props => props.theme.flexCol};
  position: relative;
  &:hover .fareTooltip {
    display: block;
  }
`;

export const RadioLabel = styled.div`
  position: relative;
  &:hover {
    cursor: pointer;
  }
  color: ${props => (props.disabled ? '#91BBF1' : props.theme.colors.goWhite.base)};
`;

export const RadioButton = styled.input`
  display: none;
  &:checked + ${RadioLabel}::before {
    content: '';
    background: ${props => props.theme.colors.goWhite.base};
    box-shadow: inset 0 0 0 3px #0069e2;
  }
  & + ${RadioLabel}::before {
    content: '';
    /* background: transparent; */
    // border: ${props => `2px solid ${props.theme.colors.goWhite.base}`};
    border: ${props => `2px solid ${props.disabled ? '#7AADEE' : props.theme.colors.goWhite.base}`};
    display: inline-block;
    vertical-align: middle;
    width: 20px;
    height: 20px;
    margin-right: 1rem;
    text-align: center;
    margin-top: -4px;
    border-radius: 50%;
  }
`;

export const LabelText = styled.span`
  font-size: ${props => props.theme.font.custom(13)};
  /* color: #000000; */
  font-family: 'Quicksand';
  font-weight: 700;
  & .newTag {
    background: #ff3a5c;
    border-radius: 2px;
    padding: 1px 4px;
    font-size: 9px;
  }
`;
export const FareTypeTooltip = styled.div`
  box-shadow: 0px 4px 6px rgba(195, 187, 200, 0.3);
  background: #fff;
  width: ${props => props.tipWidth};
  padding: 15px;
  position: absolute;
  top: 34px;
  border-radius: 8px;
  color: #141823;
  font-size: 12px;
  display: none;
  left: -70px;
  &.extraSeatTip {
    padding: 30px 30px;
  }
  & .extraSeatDesc {
    font-size: 16px;
    list-style-type: decimal;
    padding: 0 16px;
    & li {
      margin-bottom: 7px;
    }
  }
  &:before {
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid #fff;
    content: '';
    position: absolute;
    left: 130px;
    top: -8px;
  }
`;
